import React from 'react'
import "./oflline.css"
const Ofline = () => {

  return (
    <div className='container--offline'>  
    <div className='offline'>
       <h1 className='title'>404</h1>
       <br></br>
       <h2 className='titl2'>Check you connection </h2>
    </div>
    </div>
  )
}

export default Ofline